class ProductSlider extends SliderComponent {
  constructor() {
    super();

    this.DESKTOP_START_INDEX_BREAKPOINT = 1500;
    this.desktopStartIndex = parseInt(this.dataset.desktopStartIndex, 10) || 0;
  }

  /**
   * Initialises pagination while applying desktop-only start index behavior.
   */
  initPages() {
    this.applyDesktopStartIndex();

    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

    this.update();
  }

  /**
   * Applies desktop start index behavior to product slider only.
   */
  applyDesktopStartIndex() {
    const isDesktop = window.innerWidth > this.DESKTOP_START_INDEX_BREAKPOINT;
    const startIndex = isDesktop
      ? Math.min(this.desktopStartIndex, this.sliderItems.length - 1)
      : 0;

    this.sliderItems.forEach((item, index) => {
      const shouldHide = index < startIndex;

      item.toggleAttribute("hidden", shouldHide);

      if (shouldHide) {
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });

    this.navigationDots.forEach(dot => {
      const dotIndex = parseInt(dot.dataset.index, 10);
      const shouldHide = Number.isInteger(dotIndex) && dotIndex < startIndex;

      dot.toggleAttribute("hidden", shouldHide);
      dot.setAttribute("tabindex", shouldHide ? "-1" : "0");

      if (Number.isInteger(dotIndex)) {
        dot.dataset.visibleIndex = (dotIndex - startIndex).toString();
      }
    });

    this.slider.scrollLeft = 0;
  }
}

customElements.define('product-slider', ProductSlider);